import React from "react";
import "./Account.css";
import { Modal, Row, Col, Button, Alert, Form, FormCheck } from "react-bootstrap";
import { Field, Form as ReactFinalForm } from "react-final-form";
import { connect } from "react-redux";
import { accountDetailsUser, unsubscribeUserSettings, resubscribeUserSettings } from "../../actions/userActions";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import history from "../../config/history"
import { pageview } from "../../utils/googleAnalyticsUtils";


class Account extends React.Component {

  async componentDidMount() {
    pageview('Settings-Account');
    await this.props.accountDetailsUser();
  }

  renderError({ touched, error }) {
    if (touched && error) return <div className="text-danger"> {error} </div>;
  }

  renderInput = ({ input, label, meta, type }) => {

    return (
      <div className={`form-group row`}>
        <label className="col-4 col-sm-2 col-form-label"> {label} </label>
        <input
          type={type}
          {...input}
          className={`form-control col-7 col-sm-5 ${meta.touched && meta.error ? "is-invalid" : ""
            }`}
        />
        {this.renderError(meta)}
      </div>
    );
  };

  onSubmit = (formValues) => {
    // this.props.account(formValues)
  };

  renderSubscribedToDailyMail() {
    return (
      <div>
        <p>You are subscribed to daily mail. Click on the button below to unsubscribe.</p>
        <div onClick={() => this.props.unsubscribeUserSettings()} className="btn btn-danger btn-sm">Unsubscribe</div>
      </div>
    )
  }

  renderNotSubscribedToDailyMail() {
    return (
      <div>
        <p>You are not subscribed to the daily mail. Click on the button below to subscribe.</p>
        <div onClick={() => this.props.resubscribeUserSettings()} className="btn btn-success btn-sm">Subscribe</div>
      </div>
    )
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-1 col-sm-2  col-12">Name: </div>
          <div className="col-md-11 col-sm-10 col-12">{this.props.accountDetails && this.props.accountDetails.name}</div>
        </div>
        <div className="row mt-2">
          <div className="col-md-1 col-sm-2 col-12">Email: </div>
          <div className="col-md-11 col-sm-10 col-12">{this.props.accountDetails && this.props.accountDetails.email}</div>
        </div>
        {this.props.accountDetails && this.props.accountDetails.isPremium && (
          <div className="mt-2">{this.props.accountDetails && (this.props.accountDetails.subscribedToDailyMail ? this.renderSubscribedToDailyMail() : this.renderNotSubscribedToDailyMail())}</div>
        )}
        <div className="row">
          <button
            type="button"
            className="btn btn-link"
            onClick={() => history.push("/users/pwdReset")}
          >
            Reset Password
          </button>
        </div>
        {/* <ReactFinalForm
          // initialValues={this.props.videoToEdit}
          onSubmit={this.onSubmit}
          render={({ handleSubmit, form, submitting, pristine, values }) => {
            return (
              <form onSubmit={handleSubmit}>
                {this.props.error && (
                  <Alert variant="danger">
                    <p>{this.props.error}</p>
                  </Alert>
                )}

                <Field name="name">
                  {({ input, meta }) => (
                    <div>
                      <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm={2}>Name</Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            {...input}
                            type="text"
                            // placeholder="Enter Name"
                            // value={this.props.videoToEdit.description}
                            name="name"
                            className="account-form-input form-control-plaintext"
                            readOnly
                          />
                        </Col>
                      </Form.Group>
                    </div>
                  )}
                </Field>
                <Field name="email">
                  {({ input, meta }) => (
                    <div>
                      <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm={2}>Email</Form.Label>
                        <Col xl={6} md={8} sm={10}>
                          <Form.Control
                            {...input}
                            type="email"
                            // placeholder="Enter Email ID"
                            name="email"
                            // value={this.props.videoToEdit.title}
                            autofocus
                            className="account-form-input form-control-plaintext"
                            readOnly
                            value="hello"
                          />
                        </Col>
                      </Form.Group>
                    </div>
                  )}
                </Field>

                <button
                  className="btn btn-warning"
                  style={{ marginTop: "15px" }}
                  type="submit"
                >
                  submit
                </button>
              </form>
            );
          }}
        /> */}
      </div>
    );
  }
}

const validate = (formValues) => {
  const errors = {};

  if (!formValues.firstt_Namee)
    errors.firstt_Namee = "Please enter a firstt_Namee";
  else if (formValues.firstt_Namee.length > 40)
    errors.firstt_Namee =
      "Please enter a firstt_Namee shorter that 40 characters";

  if (!formValues.lastt_Namee)
    errors.lastt_Namee = "Please enter a lastt_Namee";
  else if (formValues.lastt_Namee.length > 40)
    errors.lastt_Namee =
      "Please enter a lastt_Namee shorter that 40 characters";

  if (!formValues.emaill) errors.emaill = "Required";
  else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues.emaill))
    errors.emaill = "Invalid email address";

  if (!formValues.number) errors.phone_no = "Required";
  else if (formValues.phone_no > 17) errors.phone_no = "Invalid Phone Number";

  return errors;
};

const mapStateToProps = (state) => {
  return {
    accountDetails: state.userAccountDetails.userAccountDetails
  };
};
export default connect(mapStateToProps, {
  accountDetailsUser, unsubscribeUserSettings, resubscribeUserSettings

})(Account);